import AnalyticsManagerBase from "./../../../src/common/analytics/analyticsmanagerbase";
import AnalyticsEngineER from "./../../../src/common/analytics/engines/analyticsEngineER";
import AnalyticsEngineTealium from "./engines/analyticsEngineTealium";

export default class AnalyticsManager extends AnalyticsManagerBase {
  constructor(options) {
    super(options);
    this._initEngines();
  }

  _initEngines() {
    new AnalyticsEngineER(this, this._options);
    new AnalyticsEngineTealium(this, this._options);
  }
}



// WEBPACK FOOTER //
// ./clients/rcs-gds/js/analyticsManager.js